import Vue from 'vue'
import Show from './Show'
import Edit from './Edit'

Vue.component('UserShow', Show)
Vue.component('UserEdit', Edit)
